var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "max-width": "100%" }, attrs: { id: "newQianniuex" } },
    [
      _c("input", {
        ref: "fileInputSix",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".csv" },
        on: { change: _vm.onSixFileChange }
      }),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("1、登录拼多多商家版")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src: "http://res.study.itaojin.cn/pdd1.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerFirst",
                      attrs: {
                        steps: _vm.scenarioConfig.first.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.first.initialStepId,
                        "initial-form": _vm.scenarioConfig.first.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("first")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("first", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "first",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tip-body" },
                    [
                      _vm.tabCurrent === "first" &&
                      _vm.currentStepId.first === "login2"
                        ? [
                            _c("p", [_vm._v("1.复制粘贴账号和密码")]),
                            _vm._v(" "),
                            _c("p", [_vm._v("2.自动登录不要勾选")]),
                            _vm._v(" "),
                            !_vm.showLoginPassword
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        _vm.showLoginPassword = true
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t获取账号密码\n\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showLoginPassword
                              ? [
                                  _c("p", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-weight": "normal"
                                        }
                                      },
                                      [_vm._v("账号：淘金云客服:小淘")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-weight": "normal"
                                        }
                                      },
                                      [_vm._v("密码：Tj1234")]
                                    )
                                  ])
                                ]
                              : _vm._e()
                          ]
                        : [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.rightTip.first)
                              }
                            })
                          ]
                    ],
                    2
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "stoptip",
                staticStyle: { height: "696px" },
                attrs: { id: "studytip-first" }
              },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("@/assets/images/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-登录拼多多商家版.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.first
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("first", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("first")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("2、基础设置")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src: "http://res.study.itaojin.cn/pdd2.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerSecond",
                      attrs: {
                        steps: _vm.scenarioConfig.second.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.second.initialStepId,
                        "initial-form": _vm.scenarioConfig.second.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("second")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("second", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "second",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.second) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("@/assets/images/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-基础设置.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.second
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("second", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("second")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("3、订单管理")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src: "http://res.study.itaojin.cn/pdd3.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerThird",
                      attrs: {
                        steps: _vm.scenarioConfig.third.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.third.initialStepId,
                        "initial-form": _vm.scenarioConfig.third.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("third")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("third", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "third",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.third) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("@/assets/images/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-订单管理常用功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.third
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("third", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("third")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [
                  _vm._v("4、会话窗口常用功能")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src: "http://res.study.itaojin.cn/pdd4.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerFour",
                      attrs: {
                        steps: _vm.scenarioConfig.four.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.four.initialStepId,
                        "initial-form": _vm.scenarioConfig.four.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("four")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("four", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "four",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.four) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("@/assets/images/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-会话窗口常用功能.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.four
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("four", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("four")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("5、插件常用功能")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src: "http://res.study.itaojin.cn/pdd5.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerFive",
                      attrs: {
                        steps: _vm.scenarioConfig.five.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.five.initialStepId,
                        "initial-form": _vm.scenarioConfig.five.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("five")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("five", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "five",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.five) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("@/assets/images/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-插件常用功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.five
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("five", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("five")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("6、添加快捷回复")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src: "http://res.study.itaojin.cn/pdd6.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerSix",
                      attrs: {
                        steps: _vm.scenarioConfig.six.steps,
                        "initial-step-id": _vm.scenarioConfig.six.initialStepId,
                        "initial-form": _vm.scenarioConfig.six.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("six")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("six", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "six",
                            stepId,
                            step,
                            resolvedTip
                          )
                        },
                        "request-file": _vm.onRequestFile,
                        "download-file": _vm.downloadKjdyFile
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.six) }
                  }),
                  _vm._v(" "),
                  _vm.rightTip.third && _vm.rightTip.six.indexOf("下载") !== -1
                    ? _c("p", [
                        _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                          _vm._v("点击下载“快捷短语.csv”")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudy }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("@/assets/images/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-添加快捷回复.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.six
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("six", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("six")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "seven" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("7、退出账号")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-seven" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "seven",
                      src: "http://res.study.itaojin.cn/pdd7.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c("StepPlayer", {
                      ref: "playerSeven",
                      attrs: {
                        steps: _vm.scenarioConfig.seven.steps,
                        "initial-step-id":
                          _vm.scenarioConfig.seven.initialStepId,
                        "initial-form": _vm.scenarioConfig.seven.initialForm,
                        "show-tip": false
                      },
                      on: {
                        finish: function($event) {
                          return _vm.onFinish("seven")
                        },
                        "guard-failed": function($event) {
                          return _vm.onGuardFailed("seven", $event)
                        },
                        "step-change": function(stepId, step, resolvedTip) {
                          return _vm.onStepChange(
                            "seven",
                            stepId,
                            step,
                            resolvedTip
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("提示")
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "tip-body",
                    domProps: { innerHTML: _vm._s(_vm.rightTip.seven) }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("你已完成拼多多的功能学习，"),
                        _c("br"),
                        _vm._v("接下来请完成《拼多多模拟实操》。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: { width: "160px" },
                          attrs: { href: "/tjkStudy/simulate/pddExam" }
                        },
                        [_vm._v("去完成拼多多模拟实操")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("@/assets/images/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("拼多多练习-退出账号.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt.seven
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("seven", false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt("seven")
                                    }
                                  }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer7" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7478846", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7478846","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/simulate/pddStudy.vue
// module id = 1292
// module chunks = 0